import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './hero17.css'

const Hero17 = (props) => {
  return (
    <div className="hero17-header78">
      <div className="hero17-column thq-section-padding thq-section-max-width">
        <div className="hero17-content1">
          <h1 className="hero17-text1 thq-heading-1">
            {props.heading1 ?? (
              <Fragment>
                <span className="hero17-text6">
                  Launch Your Startup in Abu Dhabi with Ease: Hassle-Free
                  Business Setup + BPO Support
                </span>
              </Fragment>
            )}
          </h1>
          <p className="hero17-text2 thq-body-large">
            {props.content1 ?? (
              <Fragment>
                <span className="hero17-text8">
                  Hassle-Free Business Setup + BPO Support
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <div className="hero17-actions">
          <button className="thq-button-filled hero17-button1">
            <span className="thq-body-small">
              {props.action1 ?? (
                <Fragment>
                  <span className="hero17-text5">Get Started</span>
                </Fragment>
              )}
            </span>
          </button>
          <button className="thq-button-outline hero17-button2">
            <span className="thq-body-small">
              {props.action2 ?? (
                <Fragment>
                  <span className="hero17-text7">Learn More</span>
                </Fragment>
              )}
            </span>
          </button>
        </div>
      </div>
      <div className="hero17-content2">
        <div className="hero17-row-container1 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt21}
              src={props.image1Src21}
              className="hero17-placeholder-image10 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image2Alt11}
              src={props.image2Src11}
              className="hero17-placeholder-image11 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image3Alt11}
              src={props.image3Src11}
              className="hero17-placeholder-image12 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image4Alt11}
              src={props.image4Src11}
              className="hero17-placeholder-image13 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image5Alt11}
              src={props.image5Src11}
              className="hero17-placeholder-image14 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt11}
              src={props.image6Src11}
              className="hero17-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt2}
              src={props.image1Src2}
              className="hero17-placeholder-image16 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image2Alt1}
              src={props.image2Src1}
              className="hero17-placeholder-image17 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image3Alt1}
              src={props.image3Src1}
              className="hero17-placeholder-image18 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image4Alt1}
              src={props.image4Src1}
              className="hero17-placeholder-image19 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image5Alt1}
              src={props.image5Src1}
              className="hero17-placeholder-image20 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt1}
              src={props.image6Src1}
              className="hero17-placeholder-image21 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
        <div className="hero17-row-container2 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt}
              src={props.image7Src}
              className="hero17-placeholder-image22 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image8Alt}
              src={props.image8Src}
              className="hero17-placeholder-image23 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image9Alt}
              src={props.image9Src}
              className="hero17-placeholder-image24 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image10Alt}
              src={props.image10Src}
              className="hero17-placeholder-image25 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image11Alt}
              src={props.image11Src}
              className="hero17-placeholder-image26 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image12Alt}
              src={props.image12Src}
              className="hero17-placeholder-image27 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt1}
              src={props.image7Src1}
              className="hero17-placeholder-image28 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image8Alt1}
              src={props.image8Src1}
              className="hero17-placeholder-image29 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image9Alt1}
              src={props.image9Src1}
              className="hero17-placeholder-image30 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image10Alt1}
              src={props.image10Src1}
              className="hero17-placeholder-image31 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image11Alt1}
              src={props.image11Src1}
              className="hero17-placeholder-image32 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image12Alt1}
              src={props.image12Src1}
              className="hero17-placeholder-image33 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="hero17-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Hero17.defaultProps = {
  image2Src1: '/2-1500w.png',
  image1Src: '2ebbb3dc-77e3-460f-9171-2bdbad05970c',
  image4Alt1: 'Hero Image',
  image11Alt1: 'Hero Image',
  image1Src21: '/1-1500w.jpg',
  image12Alt1: 'Hero Image',
  image7Src: '/7-1500w.png',
  image6Src: '26a925d9-21e2-4ab9-bfd1-728a8f8a4f8c',
  image2Alt11: 'Hero Image',
  image4Src1: '/4-1500w.png',
  image8Src1: '/8-1500w.webp',
  image3Alt11: 'Hero Image',
  image3Alt1: 'Hero Image',
  image4Alt11: 'Hero Image',
  image1Alt2: 'Hero Image',
  image11Src1: '/11-1500w.png',
  image8Src: '/8-1500w.webp',
  image5Alt11: 'Hero Image',
  action1: undefined,
  image1Src2: '/1-1500w.jpg',
  image2Src: '82c4c0fd-b139-4def-8d37-ecb8e2baacd2',
  heading1: undefined,
  image10Src1: '/10-1500w.jpeg',
  image4Src: 'b8aafed8-5b15-4f49-a9da-03a2b3df70b7',
  image6Src11: '/6-1500w.png',
  image10Alt: 'Hero Image',
  image4Src11: '/4-1500w.png',
  image7Src1: '/7-1500w.png',
  image7Alt1: 'Hero Image',
  image9Alt: 'Hero Image',
  image5Src: 'a33d8fed-33ef-4fbb-b9fd-83dca0be3be8',
  image10Alt1: 'Hero Image',
  image3Src11: '/3-1500w.jpeg',
  image5Alt1: 'Hero Image',
  image10Src: '/10-1500w.jpeg',
  image11Src: '/11-1500w.png',
  image9Alt1: 'Hero Image',
  image1Alt21: 'Hero Image',
  image6Alt11: 'Hero Image',
  image9Src: '/9-1500w.png',
  action2: undefined,
  image3Src1: '/3-1500w.jpeg',
  image5Src11: '/5-1500w.jpeg',
  image8Alt1: 'Hero Image',
  image9Src1: '/9-1500w.png',
  image6Src1: '/6-1500w.png',
  image8Alt: 'Hero Image',
  image12Src: '/12-1500w.png',
  image6Alt1: 'Hero Image',
  image12Alt: 'Hero Image',
  content1: undefined,
  image12Src1: '/12-1500w.png',
  image2Src11: '/2-1500w.png',
  image7Alt: 'Hero Image',
  image5Src1: '/5-1500w.jpeg',
  image3Src: 'a71fd4af-b6ae-4396-9e11-42a9891afa9b',
  image11Alt: 'Hero Image',
  image2Alt1: 'Hero Image',
}

Hero17.propTypes = {
  image2Src1: PropTypes.string,
  image1Src: PropTypes.string,
  image4Alt1: PropTypes.string,
  image11Alt1: PropTypes.string,
  image1Src21: PropTypes.string,
  image12Alt1: PropTypes.string,
  image7Src: PropTypes.string,
  image6Src: PropTypes.string,
  image2Alt11: PropTypes.string,
  image4Src1: PropTypes.string,
  image8Src1: PropTypes.string,
  image3Alt11: PropTypes.string,
  image3Alt1: PropTypes.string,
  image4Alt11: PropTypes.string,
  image1Alt2: PropTypes.string,
  image11Src1: PropTypes.string,
  image8Src: PropTypes.string,
  image5Alt11: PropTypes.string,
  action1: PropTypes.element,
  image1Src2: PropTypes.string,
  image2Src: PropTypes.string,
  heading1: PropTypes.element,
  image10Src1: PropTypes.string,
  image4Src: PropTypes.string,
  image6Src11: PropTypes.string,
  image10Alt: PropTypes.string,
  image4Src11: PropTypes.string,
  image7Src1: PropTypes.string,
  image7Alt1: PropTypes.string,
  image9Alt: PropTypes.string,
  image5Src: PropTypes.string,
  image10Alt1: PropTypes.string,
  image3Src11: PropTypes.string,
  image5Alt1: PropTypes.string,
  image10Src: PropTypes.string,
  image11Src: PropTypes.string,
  image9Alt1: PropTypes.string,
  image1Alt21: PropTypes.string,
  image6Alt11: PropTypes.string,
  image9Src: PropTypes.string,
  action2: PropTypes.element,
  image3Src1: PropTypes.string,
  image5Src11: PropTypes.string,
  image8Alt1: PropTypes.string,
  image9Src1: PropTypes.string,
  image6Src1: PropTypes.string,
  image8Alt: PropTypes.string,
  image12Src: PropTypes.string,
  image6Alt1: PropTypes.string,
  image12Alt: PropTypes.string,
  content1: PropTypes.element,
  image12Src1: PropTypes.string,
  image2Src11: PropTypes.string,
  image7Alt: PropTypes.string,
  image5Src1: PropTypes.string,
  image3Src: PropTypes.string,
  image11Alt: PropTypes.string,
  image2Alt1: PropTypes.string,
}

export default Hero17
